/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CustomerOrderStatus {
  DELIVERED="DELIVERED",
MISSED="MISSED",
NOT_SCHEDULED="NOT_SCHEDULED",
SCHEDULED="SCHEDULED"
}

/**
* CustomerOrderStatus
*/
export const CustomerOrderStatusEnumType = types.enumeration("CustomerOrderStatus", [
        "DELIVERED",
  "MISSED",
  "NOT_SCHEDULED",
  "SCHEDULED",
      ])
